import DashboardPage from '../pages/dashboard-page.vue'
export default [
  {
    component: DashboardPage,
    name: 'dashboard',
    path: '/:slug/dashboard',
  },
]
